export default "__VITE_ASSET__aa8339e6__"